import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class UspvsService extends BaseApiService {
    UspvsCheck(passportNumber: string, dateOfBirth: string) {
        return this.post('Customer/Uspvs/Check', { passportNumber, dateOfBirth }, this.replacer);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
